import { styled } from "@mui/material/styles";

const StyledTooltipContainer = styled("div")`
  position: relative;
  display: inline-flex;
  max-width: max-content;
  cursor: pointer;
`;

const StyledTooltip = styled("div")`
  position: absolute;
  box-sizing: border-box;
  z-index: 10;
  width: 250px;
  padding: 14px;
  background-color: ${({ theme }) => theme.palette.common.white};
  opacity: 0;
  visibility: hidden;
  text-align: left;
  box-shadow: 6px 12px 24px 0px rgba(156, 168, 191, 0.24);
  border-radius: 8px;
  visibility: hidden;
  transition: opacity 0.2s ease;

  & .tooltip-text {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.bodyM?.fontSize};
    line-height: ${({ theme }) => theme.typography.bodyM?.lineHeight};
    width: 100%;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.palette.common.black};
  }

  &.tooltip_lg {
    width: 350px;
  }

  &.tooltip_auto {
    width: max-content;
    max-width: 350px;
  }

  &.tooltip_open {
    visibility: visible;
    opacity: 1;
    z-index: 999;
    transition: opacity 0.2s ease;
  }

  & .tooltip-triangle {
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    box-shadow: 6px 12px 24px 0px rgba(156, 168, 191, 0.24);

    &::after {
      position: absolute;
      top: 0;
      z-index: 0;
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
      content: "";
    }
  }

  &.tooltip_top-left {
    top: 0;
    left: 50%;
    transform: translateX(-17px) translateY(calc(-100% - 12px));

    & .tooltip-triangle {
      bottom: 0;
      left: 0;
      border-color: ${({ theme }) =>
        `${theme.palette.common.white} transparent transparent transparent`};
      border-width: 8px 6px 0 6px;
      transform: translateX(10px) translateY(100%);
    }

    & .tooltip-triangle:after {
      border-color: ${({ theme }) =>
        `${theme.palette.common.white} transparent transparent transparent`};
      border-width: 8px 6px 0px 6px;
      transform: translateY(-10px) translateX(-6px);
    }
  }

  &.tooltip_top-right {
    top: 0;
    right: 50%;
    transform: translateX(17px) translateY(calc(-100% - 12px));

    & .tooltip-triangle {
      right: 0;
      bottom: 0;
      border-color: ${({ theme }) =>
        `${theme.palette.common.white} transparent transparent transparent`};
      border-width: 8px 6px 0 6px;
      transform: translateX(-10px) translateY(100%);
    }

    & .tooltip-triangle:after {
      border-color: ${({ theme }) =>
        `${theme.palette.common.white} transparent transparent transparent`};
      border-width: 8px 6px 0px 6px;
      transform: translateY(-9px) translateX(-6px);
    }
  }

  &.tooltip_bottom-left {
    bottom: 0;
    left: 50%;
    transform: translateX(-17px) translateY(calc(100% + 12px));

    & .tooltip-triangle {
      top: 0;
      left: 0;
      border-color: ${({ theme }) =>
        `transparent transparent ${theme.palette.common.white} transparent`};
      border-width: 0 6px 8px 6px;
      transform: translateX(10px) translateY(-100%);
    }

    & .tooltip-triangle:after {
      border-color: ${({ theme }) =>
        `transparent transparent ${theme.palette.common.white} transparent`};
      border-width: 0px 6px 8px 6px;
      transform: translateY(2px) translateX(-6px);
    }
  }

  &.tooltip_bottom-right {
    right: 50%;
    bottom: 0;
    transform: translateX(17px) translateY(calc(100% + 12px));

    & .tooltip-triangle {
      top: 0;
      right: 0;
      border-color: ${({ theme }) =>
        `transparent transparent ${theme.palette.common.white} transparent`};
      border-width: 0 6px 8px 6px;
      transform: translateX(-10px) translateY(-100%);
    }

    & .tooltip-triangle:after {
      border-color: ${({ theme }) =>
        `transparent transparent ${theme.palette.common.white} transparent`};
      border-width: 0px 6px 8px 6px;
      transform: translateY(2px) translateX(-6px);
    }
  }

  &.tooltip_right {
    top: 50%;
    right: 0;
    transform: translateX(calc(100% + 13px)) translateY(-50%);

    & .tooltip-triangle {
      top: 50%;
      left: 0;
      border-color: ${({ theme }) =>
        `transparent ${theme.palette.common.white} transparent transparent`};
      border-width: 6px 8px 6px 0;
      transform: translateX(-100%) translateY(-50%);
    }

    & .tooltip-triangle:after {
      left: 0;
      border-color: ${({ theme }) =>
        `transparent ${theme.palette.common.white} transparent transparent`};
      border-width: 6px 8px 6px 0px;
      transform: translateY(-6px) translateX(2px);
    }
  }

  &.tooltip_left {
    top: 50%;
    left: 0;
    transform: translateX(calc(-100% - 13px)) translateY(-50%);

    & .tooltip-triangle {
      top: 50%;
      right: 0;
      border-color: ${({ theme }) =>
        `transparent transparent transparent ${theme.palette.common.white}`};
      border-width: 6px 0 6px 8px;
      transform: translateX(100%) translateY(-50%);
    }

    & .tooltip-triangle:after {
      right: 0;
      border-color: ${({ theme }) =>
        `transparent transparent transparent ${theme.palette.common.white}`};
      border-width: 6px 0px 6px 8px;
      transform: translateY(-6px) translateX(-2px);
    }
  }
`;

export { StyledTooltipContainer, StyledTooltip };
